"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MealVkusvillLcmlFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MealVkusvillLcmlFilled = function MealVkusvillLcmlFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M35.62 10.37a5.744 5.744 0 00-3.707-3.17L31.33 7l-.398 1.164.582.199a4.596 4.596 0 012.972 2.466c.32.861.39 1.796.2 2.695a6.005 6.005 0 00-.981-1.44c-2.482-2.74-8.073-4.548-13.924-2.726l-.582.184.367 1.164.582-.184c5.316-1.654 10.478 0 12.653 2.39a3.277 3.277 0 01.858 3.553l-.092.183H12.32A8.686 8.686 0 004 25.324 8.682 8.682 0 0012.32 34h5.117a3.34 3.34 0 002.481-1.118l3.064-3.339a.398.398 0 00-.291-.658h-4.78a2.817 2.817 0 00-2.098.934l-.934 1.057h-2.405a3.401 3.401 0 01-3.462-3.063 3.277 3.277 0 013.278-3.446h11.734a11.613 11.613 0 0010.922-7.657 7.81 7.81 0 00.689-6.28m-9.007 10.032a1.363 1.363 0 110-2.727 1.363 1.363 0 010 2.727z",
    fill: "#97BA1E"
  }));
};

exports.MealVkusvillLcmlFilled = MealVkusvillLcmlFilled;
var _default = MealVkusvillLcmlFilled;
exports.default = _default;